const directions = [
  {
    number: '01',
    icon: 'ri-eye-line',
    title: 'Первый экран и Оффер',
    text: 'Проверка по правилу 3-х секунд. Поймёт ли клиент вашу выгоду с первого взгляда?',
  },
  {
    number: '02',
    icon: 'ri-pulse-line',
    title: 'Техническое здоровье',
    text: 'Анализ скорости (цель 1–2 сек) и безупречной адаптивности на всех устройствах.',
  },
  {
    number: '03',
    icon: 'ri-hand-coin-line',
    title: 'Юзабилити (Удобство)',
    text: 'Поиск барьеров, которые мешают пользователю нажать кнопку CTA.',
  },
  {
    number: '04',
    icon: 'ri-brain-line',
    title: 'Маркетинговая логика',
    text: 'Проверка соответствия контента этапам осознания клиента.',
  },
];

export default function AuditSolution() {
  return (
    <section className="py-16 md:py-24 bg-[#F8F9FA] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#1A2B4C]/8 border border-[#1A2B4C]/20 rounded-full px-4 sm:px-5 py-2 mb-5 md:mb-6">
            <i className="ri-search-eye-line text-[#1A2B4C] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs sm:text-sm font-semibold font-['Montserrat'] uppercase tracking-widest">Решение и экспертность</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-5 md:mb-6 font-['Playfair_Display'] leading-tight max-w-4xl mx-auto">
            Аудит веб-сайта — это взгляд профессионального маркетолога сквозь призму{' '}
            <span className="text-[#C5A880]">208 параметров</span>
          </h2>
          <div className="w-20 h-1 bg-[#C5A880] mx-auto rounded-full mb-5 md:mb-6"></div>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Мы проводим глубокое исследование вашего ресурса по <strong className="text-[#1A2B4C]">4 базовым направлениям:</strong>
          </p>
        </div>

        {/* Directions grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-10 md:mb-14">
          {directions.map((item) => (
            <div
              key={item.number}
              className="bg-white rounded-2xl p-5 sm:p-7 border border-[#C5A880]/20 hover:border-[#C5A880]/60 transition-all duration-300 group relative overflow-hidden"
            >
              {/* Ghost number */}
              <div className="absolute top-3 right-4 text-7xl font-bold text-[#1A2B4C]/5 font-['Playfair_Display'] leading-none select-none">
                {item.number}
              </div>
              <div className="flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 bg-[#1A2B4C] group-hover:bg-[#C5A880] rounded-2xl mb-4 sm:mb-5 transition-all duration-300">
                <i className={`${item.icon} text-[#C5A880] group-hover:text-[#1A2B4C] text-xl sm:text-2xl transition-colors duration-300`}></i>
              </div>
              <div className="text-[#C5A880] text-xs font-bold font-['Montserrat'] uppercase tracking-widest mb-2">
                Направление {item.number}
              </div>
              <h3 className="text-[#1A2B4C] font-bold text-base mb-3 font-['Playfair_Display']">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed font-['Montserrat'] text-justify">{item.text}</p>
            </div>
          ))}
        </div>

        {/* Expert + Card Banner */}
        <div className="grid grid-cols-1 md:grid-cols-2 rounded-3xl overflow-hidden border-2 border-[#C5A880]/30">
          {/* Left: Photo — 50% */}
          <div className="flex flex-col bg-[#1A2B4C]">
            <img
              src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/353a1b52fb77cf7e2c624e877b9048b3.png"
              alt="Ирина Шарова-Ялынпала — Маркетолог-стратег"
              className="w-full h-auto block"
              style={{ display: 'block' }}
            />
            {/* Caption */}
            <div className="bg-[#1A2B4C] px-6 sm:px-8 py-4 sm:py-5">
              <p className="text-white font-bold text-base sm:text-lg font-['Playfair_Display'] leading-snug">
                Ирина Шарова-Ялынпала
              </p>
              <p className="text-[#C5A880] text-sm font-['Montserrat'] mt-1 leading-relaxed">
                Маркетолог-стратег. Эксперт по системному маркетингу
              </p>
            </div>
          </div>

          {/* Right: Card — 50% */}
          <div className="bg-gradient-to-br from-[#1A2B4C] to-[#2A3B5C] flex flex-col justify-center p-7 sm:p-10 md:p-10 lg:p-14 gap-5 sm:gap-6">
            <div className="flex items-end gap-3 sm:gap-4">
              <div className="text-6xl sm:text-8xl font-bold text-[#C5A880] font-['Playfair_Display'] leading-none">208</div>
              <div className="text-white/60 text-sm font-['Montserrat'] mb-2 sm:mb-3 leading-tight">
                пунктов<br />проверки
              </div>
            </div>

            <div className="w-16 h-px bg-[#C5A880]/50"></div>

            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white font-['Playfair_Display'] leading-snug">
              Ваш бизнес заслуживает<br />
              <span className="text-[#C5A880]">системного подхода</span>
            </h3>

            <p className="text-white/70 leading-relaxed font-['Montserrat'] text-sm sm:text-base max-w-lg text-justify">
              Каждый пункт чек-листа — это конкретное действие, которое влияет на конверсию. Ни один критичный параметр не будет пропущен.
            </p>

            <div>
              <a
                href="#final-cta"
                className="inline-block bg-[#C5A880] hover:bg-[#B39770] text-[#1A2B4C] px-8 sm:px-10 py-4 rounded-full font-bold font-['Montserrat'] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                Заказать аудит
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
